module.exports = __webpack_public_path__ + "img/k17.3ec90e9c.jpg";